import fetcher from "./fetcher";

const swrConfig = {
  fetcher,
  revalidateOnFocus: false,
};

export default swrConfig;
